module.exports = __webpack_public_path__ + "img/1_6b5ccc6a3.png";